<template>
<div class="content" id="SystemIndex">
	<router-view />
</div>
</template>
<script>
export default {
    name: 'MessageIndex',
    //组件创建
    created() {
    },
    data() {
        return{
        }
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
</style>